var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgItaly(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 20,
    viewBox: "0 0 25 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5559 16.2499C24.5559 16.9867 24.275 17.6932 23.7749 18.2141C23.2748 18.7351 22.5965 19.0277 21.8892 19.0277H16.5559V0.972168H21.8892C22.5965 0.972168 23.2748 1.26483 23.7749 1.78576C24.275 2.30669 24.5559 3.01323 24.5559 3.74995V16.2499Z",
    fill: "#CE2B37"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.22257 0.972168C2.51533 0.972168 1.83705 1.26483 1.33696 1.78576C0.83686 2.30669 0.555908 3.01323 0.555908 3.74995L0.555908 16.2499C0.555908 16.9867 0.83686 17.6932 1.33696 18.2141C1.83705 18.7351 2.51533 19.0277 3.22257 19.0277H8.55591V0.972168H3.22257Z",
    fill: "#009246"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.55591 0.972168H16.5559V19.0277H8.55591V0.972168Z",
    fill: "#EEEEEE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItaly);
export default __webpack_public_path__ + "static/media/italy.2984d479.svg";
export { ForwardRef as ReactComponent };